import { Outlet, Navigate } from 'react-router-dom'
import { useTeamContext } from '../context/TeamContext'
import useCanWriteFinancials from '../hooks/useCanWriteFinancials'

/** Route-level guard: redirects team members without financial access to /dashboard. */
export default function RequireFinancialAccess() {
  const { loading } = useTeamContext()
  const allowed = useCanWriteFinancials()

  if (loading) return null
  if (!allowed) return <Navigate to="/dashboard" replace />
  return <Outlet />
}
